import { TableField } from "../models/TableField";
import { TableFieldType } from "../models/TableFieldType";

export type TableJsonEditorType = 'object' | 'array' | 'string' | 'number' | 'integer' | 'boolean' | 'null';

export type TableJsonEditorSchema = {
    type: TableJsonEditorType
    properties: any
    additionalProperties: boolean,
    minProperties?: number,
    not?: any,
    required: Array<string>
}

export class TablesJsonTableConfigurationService {

    public static getJsonEditorSchemaForField(field: TableField): TableJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: any = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: TableJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: TableFieldType | any): TableJsonEditorType | null {
        switch (fieldType) {
            case TableFieldType.Text:
                return 'string';
            case TableFieldType.Number:
                return 'number';
            case TableFieldType.Boolean:
                return 'boolean';
            case TableFieldType.Array:
                return 'array';
            case TableFieldType.Object:
            case TableFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    public static getJsonEditorSchemaForTable(): TableJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }
}
